/** User-facing strings: overview. */
export const overview = {
    title: "Overview",
    starting: "The service is starting. Retry in a few seconds.",
    retry: "Retry",
    intro: "An agent runs next to your OPC UA server and connects it to the relay, so your clients can reach it from anywhere.",
    setupCompleteBefore: "Setup is complete. Manage everything on ",
    setupCompleteLink: "Agents",
    setupCompleteAfter: ".",
    checklist: {
        title: "Get started",
        intro: "Four steps from your account to a server your clients can reach.",
        done: " (done)",
        next: " (next step)",
        todo: " (to do)",
        token: {
            title: "Get your token",
            description: "The token proves the agent belongs to your account.",
            link: "Get your token",
        },
        download: {
            title: "Download the agent",
            description: "Install it on a machine that can reach your OPC UA server.",
            link: "Download the agent",
        },
        enrol: {
            title: "Enrol the agent",
            description: "On that machine, run: opcua-relay-agent config <token>",
            link: "How to enrol the agent",
        },
        server: {
            title: "Add a server and test the connection",
            description: "Publish your OPC UA server through the agent, then use Test connection.",
            link: "Add a server",
        },
    },
    fleet: {
        title: "Fleet summary",
        agents: "Agents",
        online: "Online",
        offline: "Offline",
        disabled: "Disabled",
        servers: "Relayed servers",
        checking: "checking",
        unavailable:
            "Status unavailable for {count, plural, one {# agent} other {# agents}}: it is not counted as online or offline. It retries every 10 seconds.",
    },
    attention: {
        title: "Needs attention",
        certificateReset: "Certificate reset: enrol the agent again on its host",
        offline: "Offline",
        noServers: "No server added yet",
        nothingPartial: "Nothing to report so far. Some agent statuses are not known yet.",
        nothing: "Nothing needs attention.",
        openAgents: "Open agents",
        openAgentsFor: " for {name}",
    },
};
